import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/** Form step context: "Ticket X / Y" with a progress bar in the ticket type color, and an optional note. */
@Component({
  selector: 'app-form-progress',
  templateUrl: './form-progress.component.html',
  styleUrls: ['./form-progress.component.scss'],
  standalone: true,
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[style.--progress-accent]': 'accent' }
})
export class FormProgressComponent {
  // Ticket type color (null: primary)
  @Input() accent: string | null = null;
  // Current form (1-based) and number of forms of the ticket type; the counter is hidden when total is 0
  @Input() current: number = 0;
  @Input() total: number = 0;
  @Input() note: string | null = null;

  get percentage(): number {
    return this.total > 0 ? Math.min(100, Math.max(0, (this.current / this.total) * 100)) : 0;
  }
}
